import { BaseModel } from '@Core';
import { Camera } from './Camera';
import { CameraPhotoVehicles } from './CameraPhotoVehicles';
import { CameraView } from './CameraView';
import { DetectCarOverlapPriorityLevel } from './DetectCarOverlapQueue';
import { AiPlateDetectionResponse } from './AiPlateDetectionResponse';

export interface CameraPhotos extends BaseModel {
    CameraId: number;
    Camera?: Camera;

    BlobName: string;

    ImageSize: number;

    CaptureAt: Date;
    CaptureType: CaptureType;

    CameraPhotoVehicles?: CameraPhotoVehicles[];

    IsWithinOperationalHours?: boolean;

    DetectPlateAt?: Date;
    DetectPlateNotes?: string;
    DetectPotentialContraventionAt?: Date;
    Version?: PhotoVersion;

    ZoneId?: number;
    ViewId?: number;
    CameraView?: CameraView;

    IsPotentialObstruction?: boolean;
    ScanObstructionStatus?: PhotoScanObstructionStatus;
    ScanObstructionPriority?: DetectCarOverlapPriorityLevel;
    UsedAsEvidence?: boolean;
    AiPlateDetectionResponse?: AiPlateDetectionResponse;
}

export enum CaptureType {
    trigged,
    command,
}

export enum PhotoVersion {
    original,
    edited,
}

export enum PhotoScanObstructionStatus {
    NotScanned,
    Scanned,
    Error,
}
